/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import { registerEditorContribution } from '../../../browser/editorExtensions';
import { ToggleStickyScroll } from './stickyScrollActions';
import { StickyScrollController } from './stickyScrollController';
import { registerAction2 } from '../../../../platform/actions/common/actions';

registerEditorContribution(StickyScrollController.ID, StickyScrollController);
registerAction2(ToggleStickyScroll);
